<template>
  <div id="notifelement">
    <div class="register-notif">
      <div class="row">
        <div class="col-sm-12">
          <div class="text-center">
            <h3 class="notif-title">Registrasi Berhasil</h3>
            <hr />
            <h4 class="notif-detail">
              Terima kasih telah melakukan registrasi.
              <br />
              Anda telah terdaftar sebagai peserta
              <b> {{ dataprop.event.name }}</b>
            </h4>
            <div class="notif-qrcode">
              <img :src="getQrcode()" alt="" />
            </div>
            <p>
              Screenshot qrcode berikut untuk digunakan saat absensi/checkin.
              Qrcode juga telah dikirimkan via email.
            </p>
          </div>
          <hr />
          <p class="notif-note">
            <sup>*</sup> Periksa kotak masuk Anda untuk langkah selanjutnya.
            Jika Anda tidak menerima email, dan tidak ada di folder spam Anda,
            ini bisa berarti Anda mendaftar dengan alamat yang berbeda.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["dataprop"],
  data() {
    return {
      url: "",
    };
  },
  mounted: function () {
    var target = document.querySelector("#notifelement");
    $("html, body").animate(
      {
        scrollTop: $(target).offset().top,
      },
      500
    );
  },
  created() {
    this.initial();
  },
  methods: {
    initial() {
      console.log(this.dataprop);
    },
    getQrcode() {
      return `/assets/qrcode/${this.dataprop.qrcode}`;
    },
  },
};
</script>
<style>
.register-notif {
  color: #444;
  background-color: #fff;
  border: 2px solid #ddd;
  border-radius: 10px;
  padding: 30px 30px;
  box-shadow: 0 4px 21px -12px rgb(0 0 0 / 66%);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}
.notif-title {
  font-weight: bold;
}
.notif-detail {
  text-transform: none;
  font-weight: 400;
}
.notif-qrcode img {
  width: 50%;
}
.notif-note {
  font-size: 11px;
}

@media screen and (max-width: 768px) {
  .notif-qrcode img {
    width: 100%;
  }
}
</style>
